import axiosInstance from "./axios.instance";

const API_GET_SUPPORT_TICKETS = async (page = 0, limit = 10) => {
  try {
    const resp = await axiosInstance.get(
      `/supportticket?page=${page}&limit=${limit}&isActive=1`
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_CREATE_SUPPORT_TICKET = async (payload) => {
  try {
    const resp = await axiosInstance.post("/supportticket", payload);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const getTicketChatMessages = async (ticketId, page = 0, limit = 20) => {
  try {
    const resp = await axiosInstance.get(
      `/supportticket/${ticketId}/chat/messages?page=${page}&limit=${limit}`
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export {
  API_GET_SUPPORT_TICKETS,
  API_CREATE_SUPPORT_TICKET,
  getTicketChatMessages,
};
